import { Link } from "react-router-dom";
import { categories, mangaWorks } from "@/mocks/manga";

export default function Categories() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-9 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <p className="inline-flex items-center gap-2 text-sm text-primary-500">
            <i className="ri-snowy-line"></i> 六大冬日题材
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            想看的冬日故事，都在这里
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-6 text-foreground-600">
          按雪景、冬日、雪国、冬物语、冰雪、雪女等题材精细分类，轻松找到合口味的冷门佳作。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c, idx) => {
          const count = mangaWorks.filter((w) => w.categorySlug === c.slug).length;
          return (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200/60 bg-background-100 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/40"
            >
              <span className="absolute right-5 top-5 font-heading text-4xl font-black text-background-300/60 transition-colors group-hover:text-primary-500/30">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100/70 text-2xl text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-950">
                <i className={c.icon}></i>
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-1 text-xs uppercase tracking-widest text-foreground-500">{c.en}</p>
              <p className="mt-3 flex-1 text-sm leading-6 text-foreground-600">{c.description}</p>
              <div className="mt-5 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{count} 部代表作</span>
                <span className="inline-flex items-center gap-1 text-sm text-primary-500">
                  去看看 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}